import React from 'react';
import axios from "axios";
import {BASE_URL} from "../../../../global/Server/endpoints";
import FeedbackBar from "../../../../feedbackBar/FeedbackBar";
import {userInfoSelector} from "../../../../../redux/selectors/auth";
import withShipment from "../../../../../withShipment";
import "./ProfitSummary.css"
import {Autocomplete} from "@material-ui/lab";
import {TextField} from "@material-ui/core";

class ProfitSummary  extends React.Component {
  constructor(props) {
    super(props);

     const startYear = 2025;
    const currentYear = new Date().getFullYear();

    const YEARS = [];
    for (let year = startYear; year <= currentYear; year++) {
      YEARS.push(year);
    }

    this.state = {
      YEARS,
      selectedYear: currentYear,
      locations: [],
      profitSummary: [],
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    }

  }

   componentDidMount() {
    this.fetchLocations();
  }

  getToken = () => localStorage.getItem("token");

  fetchLocations = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/location/list`, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });
      if (res.data.success) {
        this.setState({ locations: res.data.locations},()=>{
          this.getProfitSummary()
        });
      } else {
        this.openFeedback("error", "Failed to fetch locations");
      }
    } catch (err) {
      this.openFeedback("error", `Failed to fetch locations: ${err.message}`);
    }
  };

  getProfitSummary = async () => {
    const { locations, selectedYear  } = this.state;
    if (!locations.length) return;
    try {
      const res = await axios.post(`${BASE_URL}/lizAccounting/locationYearProfitSummary`, {
        year: selectedYear,
        locations: locations.map(l => l.name)
      }, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });
      if (res.data.success) {
        const profitSummary = res.data.profitSummary

        this.setState({
          profitSummary: profitSummary,
        });
      }
       else {
        this.openFeedback("error", "Failed to fetch profit summary");
      }
    } catch (err) {
      this.openFeedback("error", `Failed to fetch profit summary: ${err.message}`);
    }
  };

  openFeedback = (severity, message) => {
    this.setState({
      feedbackBarOpen: true,
      feedbackStatus: severity,
      feedbackMessage: message,
    });
  };

  closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false });
  };

  handleYearChange = (event, value) => {
    if (value) {
      this.setState({ selectedYear: value }, () => {
        this.getProfitSummary(); // fetch new data for selected year
      });
    }
  };

  renderProfitSummary = () => {
    const { profitSummary } = this.state;
    if (!Array.isArray(profitSummary) || profitSummary.length === 0)
      return <p className="no-data">No data available</p>;

    const columns = profitSummary;
    const months = Object.keys(columns[0]?.months || {});

    return (
      <div className="profit-summary-wrapper">
        {months.map((month) => {
          // Collect all week numbers
          const weekSet = new Set();
          columns.forEach((loc) => {
            const weeks = loc.months?.[month]?.weeks;
            if (Array.isArray(weeks)) {
              weeks.forEach((w) => weekSet.add(w.week));
            }
          });
          const weeks = Array.from(weekSet).sort((a, b) => a - b);

          return (
            <div key={month} className="month-card">
              <div className="month-header">
                <h3>{month}</h3>
              </div>

              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>Week</th>
                      {columns.map((loc) => (
                        <th style={{textAlign:'right'}} key={loc.locationId}>{loc.locationName}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {weeks.map((weekNo) => (
                      <tr key={weekNo}>
                        <td>W{weekNo}</td>
                        {columns.map((loc) => {
                          const weekData = loc.months?.[month]?.weeks.find(
                            (w) => w.week === weekNo
                          );
                          const value = weekData?.profit ?? "-";
                          return (
                            <td
                              key={loc.locationId}
                              className={typeof value === "number" && value < 0 ? "negative" : ""}
                            >
                              {typeof value === "number" ? `$${value.toLocaleString()}` : "-"}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <td>Total</td>
                      {columns.map((loc) => {
                        const monthData = loc.months?.[month];
                        const total = monthData?.total ?? 0;
                        const growth = monthData?.growthPct;
                        return (
                          <td key={loc.locationId} className="bold">
                            {typeof growth === "number" && (
                              <span className={`growth ${growth >= 0 ? "positive" : "negative"}`}>
                                {growth >= 0 ? " ▲" : " ▼"}
                                {Math.abs(growth)}%
                              </span>
                            )}
                            ${total.toLocaleString()}

                          </td>
                        );
                      })}
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    );
  };


  render() {
  return (
      <div>
        <FeedbackBar
            open={this.state.feedbackBarOpen}
            severity={this.state.feedbackStatus}
            message={this.state.feedbackMessage}
            handleClose={this.closeFeedbackBar}
        />

        <div style={{marginBottom: 16,marginTop: 16, maxWidth: 200}}>

         <Autocomplete
            className="locationDateFields"
            options={this.state.YEARS} // array of numbers
            getOptionLabel={(option) => option.toString()} // convert number to string
            autoHighlight
            disableClearable
            blurOnSelect
            value={this.state.selectedYear}
            onChange={this.handleYearChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Selected year"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="selectedYear"
              />
            )}
          />
        </div>

        {this.renderProfitSummary()}

      </div>
  );
  };
}

const mapStateToProps = state => ({userInfo: userInfoSelector(state)});


export default withShipment({
  mapStateToProps,
}, ProfitSummary);
